import React from 'react';
import dynamic from 'next/dynamic';

import useKnowledgeBaseEnabled from './hooks/useKnowledgeBaseEnabled';
import useOpenCoachDrawer from './hooks/useOpenCoachDrawer';
import { CoachOrbButton } from './CoachOrbButton';

const CoachRightDrawer = dynamic(() => import('./CoachRightDrawer'), { ssr: false });

function KnowledgeBase() {
  const { isCoachOpen, openCoach, closeCoach } = useOpenCoachDrawer({
    syncInQueryParam: true,
  });

  const isKnowledgeBaseEnabled = useKnowledgeBaseEnabled();

  if (!isKnowledgeBaseEnabled) {
    return null;
  }

  return (
    <>
      <CoachOrbButton isOpen={isCoachOpen} onClick={openCoach} />
      <CoachRightDrawer isOpen={isCoachOpen} onClose={closeCoach} />
    </>
  );
}

export default React.memo(KnowledgeBase);
